export const CONTRACT_TYPES = {
  ip: 1,
  ur: 2,
  not_offer: 3,
};

export const CONTRACT_TYPES_NAMES = {
  [CONTRACT_TYPES.ip]: 'Индивидуальная запись',
  [CONTRACT_TYPES.ur]: 'Групповая запись',
};

export const AGREEMENT_TYPES = {
  oferta: 1,
  paper: 2,
};

export const AGREEMENT_TYPES_NAME = {
  [AGREEMENT_TYPES.oferta]: 'Авто-договор',
  [AGREEMENT_TYPES.paper]: 'Договор "на бумаге"',
};

export default {
  // AGREEMENT_TYPES_NAME,
  AGREEMENT_TYPES,
};
